import RecommendationService from '@Component/Recommendation/Service/RecommendationService';
import SimplePopup, {type ISimplePopup} from '@Service/LegacyBridge/SimplePopup/SimplePopup';
import EventHub from '@Service/LegacyBridge/EventHub/EventHub';

export default class RecommendationPopup {
    constructor(
        private readonly productId: number,
        private readonly popup: ISimplePopup = new SimplePopup(),
        private readonly service: RecommendationService = new RecommendationService(),
    ) {}

    public async open(): Promise<void> {
        const response = await this.service.getAlternativeRecommendation(this.productId);
        this.popup.setContent(response.html);
        this.popup.open();

        const popupContainer = document.querySelector<HTMLElement>('[data-role="popup-items-container"]');
        if (popupContainer) {
            EventHub.instance.trigger('Product.rendered', popupContainer);
        }

        EventHub.instance.trigger('OrderPopup.Opened');
    }
}
